import { TReport } from '../definitions';
import { config } from '../../../core/config/config';

export const updateReportNetwork = async (token: string, report: TReport): Promise<TReport> => {
  const response = await fetch(`${config.uri.lp_backend}/reports/analytics`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(report)
  });

  if (!response.ok) {
    throw new Error('Failed to update report');
  }

  return await response.json();
};
